// Catering Invoice Payment Related Enums

// catering_invoice_payment paymentStatus Type Enum
export enum CateringInvoicePaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  EXPIRED = 'expired',
}
